export function renderMissingEnvScreen(
  root: HTMLElement,
  missing: readonly string[],
): void {
  root.replaceChildren();

  const wrap = document.createElement("div");
  wrap.style.cssText =
    "font-family:system-ui,sans-serif;max-width:40rem;margin:4rem auto;padding:1.5rem;line-height:1.5";

  const heading = document.createElement("h1");
  heading.style.cssText = "font-size:1.25rem;margin:0 0 .75rem";
  heading.textContent = "Configuration error";

  const blurb = document.createElement("p");
  blurb.style.cssText = "margin:0 0 .75rem";
  blurb.textContent =
    "This deployment is missing required runtime configuration. " +
    "Set the following keys in the web-frontend-config ConfigMap and restart:";

  const list = document.createElement("ul");
  list.style.cssText = "margin:0;padding-left:1.25rem";
  for (const key of missing) {
    const item = document.createElement("li");
    // textContent, not innerHTML — key names must never be parsed as markup.
    item.textContent = key;
    list.append(item);
  }

  wrap.append(heading, blurb, list);
  root.append(wrap);
}
